


export const isObject = (value) =>{
    return value!=null && !Array.isArray(value) && typeof value ==='object' && typeof value !== 'function'
}
